import React from "react";
import {ARE_YOU_SHURE_MSG, ARE_YOU_SHURE_TITLE, NO, YES} from "../i18n/i18n";
import {confirmAlert} from "react-confirm-alert";
import PropTypes from "prop-types";

// data : el objeto a remover
// fbDataBaseId : la base de datos donde se dara de baja (opcional en caso de que el modelo no se envie a firebase)
// service : (opcional) el servicio del modelo
// remove : la acción que remueve, (puede ser el metodo del servicio o la acción del redux)
export const ConfirmDelete = ({
                                  path,
                                  data,
                                  fbDataBaseId,
                                  service,
                                  remove,
                                  closeOnEscape= true,
                                  closeOnClickOutside= true,
                              })  => {
    return confirmAlert({
        closeOnEscape,
        closeOnClickOutside,
        customUI: ({onClose}) => {
            return (
                <div className='custom-ui'>
                    <h1>{ARE_YOU_SHURE_TITLE}</h1>
                    <p>{ARE_YOU_SHURE_MSG}</p>
                    <button onClick={onClose}>{NO}</button>
                    <button className={"btn-alert-delete"} onClick={() => {
                        if(path !== undefined) {
                            console.log("remove whith path", path, service, data.id, fbDataBaseId)
                            remove(path, service, data.id, fbDataBaseId)
                            onClose()
                            return
                        }

                        if (service !== undefined) {
                            console.log("remove whith service", service, data.id, fbDataBaseId)
                            remove(service, data.id, fbDataBaseId)
                        }
                        else if (fbDataBaseId !== undefined) {
                            console.log("remove whith fbDataBaseId", data.id, fbDataBaseId)
                            remove(data.id, fbDataBaseId)
                        }
                        else {
                            console.log("remove whithout path, service or fbDataBaseId", data)
                            remove(data)
                        }
                        onClose();
                    }}>
                        {YES}
                    </button>
                </div>
            );
        }
    });
};

ConfirmDelete.propTypes = {
    data: PropTypes.object.isRequired,

    remove: PropTypes.func.isRequired,
};